/*eslint-disable*/
import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// reactstrap components
import { Container, Row, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Container fluid>
          <Nav>
            <NavItem>
              <NavLink href="javascript:void(0)">Link 1</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="javascript:void(0)">Link 2</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="javascript:void(0)">Link 3</NavLink>
            </NavItem>
          </Nav>
          <div className="copyright">
            © {new Date().getFullYear()} 9Stone, LLC
          </div>
        </Container>
      </footer>
    );
  }
}

export default Footer;
